/* MATLEON — ficha de producto (sections/mt-ficha.liquid). Vanilla, sin librerías.
   Galería con deslizamiento nativo + miniaturas + lupa, tallas, WhatsApp con la talla, carrito, barra fija, guía. */
(function () {
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)');
  var conRaton = window.matchMedia('(hover: hover) and (pointer: fine)');
  var EASE = 'cubic-bezier(0.23, 1, 0.32, 1)';

  function iniciar(raiz) {
    if (!raiz || raiz.dataset.mtListo) return;
    raiz.dataset.mtListo = '1';
    var D = raiz.dataset;
    var $ = function (s) { return raiz.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(raiz.querySelectorAll(s)); };
    var variantes = [];
    try { variantes = JSON.parse($('[data-mt-variantes]').textContent); } catch (e) {}

    // ================= GALERÍA =================
    var pista = $('[data-mt-fotos]');
    var fotos = $$('.mt-ficha__foto');
    var minis = $$('.mt-ficha__mini');
    var marco = $('.mt-ficha__mini-marco');
    var progreso = $('[data-mt-progreso]');
    var actualEl = $('[data-mt-actual]');
    var actual = 0;

    function marcar(i) {
      if (i === actual && raiz.dataset.mtGal) return;
      raiz.dataset.mtGal = '1';
      actual = i;
      minis.forEach(function (m, k) { var si = k === i; m.classList.toggle('es-activa', si); m.setAttribute('aria-selected', si ? 'true' : 'false'); });
      if (marco && minis[i]) marco.style.transform = 'translateY(' + minis[i].offsetTop + 'px)';
      if (progreso) progreso.style.transform = 'translateX(' + (i * 100) + '%)';
      if (actualEl) actualEl.textContent = i + 1;
    }
    // Deslizamiento propio (no el "smooth" del navegador): con el imán de las fotos (scroll-snap) prendido, el
    // navegador y el imán se peleaban y la foto se atoraba a medio camino. Aquí se apaga el imán, se mueve cuadro por
    // cuadro con una curva que frena suave, y se puede interrumpir: otro toque cambia el destino desde donde va.
    var anim = null;
    function ir(i, instantaneo) {
      if (!pista || !fotos.length) return;
      i = (i + fotos.length) % fotos.length;
      var destino = fotos[i].offsetLeft - pista.offsetLeft;
      marcar(i);
      if (anim) { cancelAnimationFrame(anim.raf); anim = null; }
      if (instantaneo || reducido.matches || Math.abs(pista.scrollLeft - destino) < 2) {
        pista.style.scrollSnapType = 'none'; pista.scrollLeft = destino; pista.style.scrollSnapType = '';
        return;
      }
      var desde = pista.scrollLeft, t0 = performance.now();
      var dur = Math.min(640, 380 + Math.abs(destino - desde) * 0.12);
      pista.style.scrollSnapType = 'none';
      anim = { raf: 0 };
      (function paso(t) {
        var k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 4); // frena suave al llegar
        pista.scrollLeft = desde + (destino - desde) * e;
        if (k < 1) { anim.raf = requestAnimationFrame(paso); return; }
        anim = null;
        pista.style.scrollSnapType = '';
      })(t0);
    }
    // Si la persona toca o desliza la galería a medio movimiento, manda ella: se suelta el deslizamiento propio
    function soltar() { if (anim) { cancelAnimationFrame(anim.raf); anim = null; pista.style.scrollSnapType = ''; } }
    // Las fotos de la galería se cargan y "decodifican" antes de que se necesiten (si no, al deslizar aparecían en blanco
    // y el primer cuadro se trababa)
    function precargar() {
      fotos.forEach(function (li) {
        var img = li.querySelector('img');
        if (!img) return;
        img.loading = 'eager';
        if (img.decode) img.decode().catch(function () {});
      });
    }
    if (document.readyState === 'complete') setTimeout(precargar, 300); else window.addEventListener('load', function () { setTimeout(precargar, 300); });
    if (pista) {
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { pista.addEventListener(ev, soltar, { passive: true }); });
      var rafScroll = null;
      pista.addEventListener('scroll', function () {
        if (anim) return; // durante el deslizamiento propio ya se marcó el destino
        if (rafScroll) return;
        rafScroll = requestAnimationFrame(function () {
          rafScroll = null;
          marcar(Math.round(pista.scrollLeft / Math.max(pista.clientWidth, 1)));
        });
      }, { passive: true });
      pista.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); ir(actual + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); ir(actual - 1); }
      });
      marcar(0);
      window.addEventListener('resize', function () { ir(actual, true); });
    }
    minis.forEach(function (m) { m.addEventListener('click', function () { ir(Number(m.dataset.ir)); }); });
    $$('[data-paso]').forEach(function (b) { b.addEventListener('click', function () { ir(actual + Number(b.dataset.paso)); }); });

    // Sin zoom al pasar el ratón (el dueño: "se ve mal"): se amplía solo con clic → vista ampliada

    // Vista ampliada (todas las fotos grandes, una debajo de otra)
    var lupa = $('[data-mt-lupa]');
    function abrirDialogo(dlg, clase) {
      if (!dlg) return;
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      document.documentElement.classList.add('mt-carro-activo');
      requestAnimationFrame(function () { requestAnimationFrame(function () { dlg.classList.add(clase); }); });
    }
    function cerrarDialogo(dlg, clase) {
      if (!dlg || !dlg.open) return;
      dlg.classList.remove(clase);
      document.documentElement.classList.remove('mt-carro-activo');
      setTimeout(function () { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); }, reducido.matches ? 150 : 340);
    }
    $$('[data-ampliar]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!lupa) return;
        abrirDialogo(lupa, 'mt-abierto');
        var li = lupa.querySelector('[data-i="' + b.dataset.ampliar + '"]');
        if (li) lupa.scrollTop = li.offsetTop - 16;
      });
    });
    if (lupa) {
      lupa.addEventListener('cancel', function (e) { e.preventDefault(); cerrarDialogo(lupa, 'mt-abierto'); });
      lupa.addEventListener('click', function (e) { if (e.target.closest('[data-mt-lupa-cerrar]') || e.target.tagName === 'IMG' || e.target === lupa) cerrarDialogo(lupa, 'mt-abierto'); });
    }

    // ================= TALLAS =================
    var grupos = $$('fieldset[data-opcion]');
    var elegidaEls = $$('[data-mt-elegida]');
    var precioEl = $('[data-mt-precio]'), precioBarra = $('[data-mt-precio-barra]'), tallaBarra = $('[data-mt-talla-barra]');
    var btnAgregar = $('[data-mt-agregar]');
    var errorEl = $('[data-mt-error]');
    var variante = null;

    function dinero(c) {
      var n = (Number(c) || 0) / 100;
      return (D.formato || '$ {{amount}}')
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(n).toLocaleString('en-US'))
        .replace(/\{\{\s*amount\s*\}\}/, n % 1 ? n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : Math.round(n).toLocaleString('en-US'))
        .replace(/^(\D+?)\s+(?=\d)/, '$1'); // MATLEON: precio limpio ($16,399)
    }
    function seleccion() {
      return grupos.map(function (g) { var r = g.querySelector('input:checked'); return r ? r.value : null; });
    }
    function buscarVariante() {
      if (!grupos.length) return variantes[0] || null;
      var sel = seleccion();
      if (sel.some(function (s) { return s === null; })) return null;
      return variantes.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); }) || null;
    }
    function tallaTexto() {
      if (!grupos.length || !variante) return '';
      return variante.options.join(' / ');
    }
    function enlaceWa() {
      var t = tallaTexto();
      var tallaTxt = t ? (D.tallaTexto || 'Talla: {talla}').replace(/\{talla\}/g, t) : (grupos.length ? (D.sinTalla || '') : '');
      var precio = variante ? dinero(variante.price) : (precioEl ? precioEl.textContent.trim() : '');
      var url = D.enlace + (variante && grupos.length ? '?variant=' + variante.id : '');
      var msg = (D.plantilla || '')
        .replace(/\{producto\}/g, D.producto || '')
        .replace(/\{talla\}/g, tallaTxt)
        .replace(/\{precio\}/g, precio)
        .replace(/\{enlace\}/g, url)
        .replace(/\n{2,}/g, '\n');
      return 'https://wa.me/' + (D.numero || '') + '?text=' + encodeURIComponent(msg);
    }
    function actualizar(cambioUsuario) {
      variante = buscarVariante();
      var sel = seleccion();
      grupos.forEach(function (g, i) {
        var el = g.querySelector('[data-mt-elegida]');
        if (el && sel[i]) { el.textContent = sel[i]; el.classList.add('es-elegida'); }
      });
      if (variante) {
        if (precioEl) precioEl.textContent = dinero(variante.price);
        if (precioBarra) precioBarra.textContent = dinero(variante.price);
        if (btnAgregar) btnAgregar.dataset.variante = variante.id;
        if (tallaBarra) tallaBarra.textContent = grupos.length ? ' · ' + (grupos.length === 1 ? 'Talla ' : '') + tallaTexto() : '';
        if (cambioUsuario && grupos.length) {
          try { history.replaceState(history.state, '', location.pathname + '?variant=' + variante.id); } catch (e) {}
          if (variante.media !== null && variante.media !== undefined && fotos[variante.media]) ir(variante.media);
        }
        if (errorEl) errorEl.textContent = '';
        raiz.classList.remove('mt-falta-talla');
      }
      $$('[data-mt-wa]').forEach(function (a) { a.href = enlaceWa(); });
    }
    grupos.forEach(function (g) { g.addEventListener('change', function () { actualizar(true); }); });
    actualizar(false);

    // Si falta la talla: aviso, las tallas se sacuden y se llevan a la vista
    function pedirTalla() {
      if (errorEl) errorEl.textContent = 'Elige tu talla para agregarla al carrito.';
      var g = grupos[0];
      if (!g) return;
      var r = g.getBoundingClientRect();
      if (r.top < 80 || r.bottom > innerHeight) window.scrollTo({ top: scrollY + r.top - 120, behavior: reducido.matches ? 'auto' : 'smooth' });
      raiz.classList.remove('mt-falta-talla');
      void raiz.offsetWidth; // reinicia la sacudida
      raiz.classList.add('mt-falta-talla');
      var primero = g.querySelector('input');
      if (primero) setTimeout(function () { primero.focus({ preventScroll: true }); }, 350);
    }

    // ================= CARRITO =================
    var ocupado = false;
    function agregar(boton) {
      if (ocupado) return;
      if (!variante) { pedirTalla(); return; }
      if (!window.MTCarrito) { location.href = '/cart/add?id=' + variante.id + '&quantity=1'; return; }
      ocupado = true;
      if (btnAgregar) btnAgregar.classList.add('es-cargando');
      window.MTCarrito.agregar(variante.id, 1).then(function () {
        if (btnAgregar) {
          btnAgregar.classList.remove('es-cargando');
          btnAgregar.classList.add('es-listo');
          setTimeout(function () { btnAgregar.classList.remove('es-listo'); }, 2200);
        }
      }).catch(function (e) {
        if (btnAgregar) btnAgregar.classList.remove('es-cargando');
        if (errorEl) errorEl.textContent = 'No se pudo agregar. Intenta de nuevo o escríbenos por WhatsApp.';
      }).then(function () { ocupado = false; });
    }
    if (btnAgregar) btnAgregar.addEventListener('click', function () { agregar(btnAgregar); });
    var btnBarra = $('[data-mt-agregar-barra]');
    if (btnBarra) btnBarra.addEventListener('click', function () { agregar(btnBarra); });

    // ================= BARRA FIJA (celular) =================
    var barra = $('[data-mt-barra-ficha]'), acciones = $('[data-mt-acciones]');
    // Se revisa al desplazarse (no con IntersectionObserver: si la página abre ya bajada —al regresar con "atrás"—
    // el observador nunca avisaba y la barra no salía)
    if (barra && acciones) {
      var verBarra = null, rafBarra = null;
      var revisarBarra = function () {
        rafBarra = null;
        var ver = acciones.getBoundingClientRect().bottom < 0;
        if (ver === verBarra) return;
        verBarra = ver;
        barra.classList.toggle('es-visible', ver);
        barra.setAttribute('aria-hidden', ver ? 'false' : 'true');
        barra.querySelectorAll('a, button').forEach(function (x) { x.tabIndex = ver ? 0 : -1; });
        document.documentElement.classList.toggle('mt-barra-activa', ver);
      };
      window.addEventListener('scroll', function () { if (!rafBarra) rafBarra = requestAnimationFrame(revisarBarra); }, { passive: true });
      revisarBarra();
    }

    // ================= COLUMNA DE INFORMACIÓN FIJA (computadora) =================
    // Las fotos van una debajo de otra y la información se queda fija a la derecha. Si la información es más alta
    // que la pantalla, primero baja con la página hasta verse completa y ya luego se queda (top negativo).
    var pegajosa = $('.mt-ficha__info');
    if (pegajosa && window.ResizeObserver) {
      var ajustarPegajosa = function () {
        pegajosa.style.top = Math.min(96, window.innerHeight - pegajosa.offsetHeight - 32) + 'px';
      };
      new ResizeObserver(ajustarPegajosa).observe(pegajosa);
      window.addEventListener('resize', ajustarPegajosa);
      ajustarPegajosa();
    }

    // ================= GUÍA DE TALLAS (panel) =================
    var guia = $('[data-mt-guia]');
    var abreGuia = $('[data-mt-abrir-guia]');
    if (guia && abreGuia) {
      abreGuia.addEventListener('click', function () { abrirDialogo(guia, 'mt-abierto'); });
      // Al abrir, el navegador enfoca la X con el panel aún abajo y recorre el diálogo para mostrarla: el panel
      // "subía y bajaba" de golpe en celular. El CSS lo impide (overflow: clip); esto cubre a los Safari viejos.
      guia.addEventListener('scroll', function () { if (guia.scrollTop) guia.scrollTop = 0; });
      guia.addEventListener('cancel', function (e) { e.preventDefault(); cerrarDialogo(guia, 'mt-abierto'); });
      guia.addEventListener('click', function (e) { if (e.target.closest('[data-mt-guia-cerrar]')) cerrarDialogo(guia, 'mt-abierto'); });
    }

    // ================= COMPARTIR =================
    var comp = $('[data-mt-compartir]');
    if (comp) comp.addEventListener('click', function () {
      var url = comp.dataset.url, txt = comp.querySelector('[data-mt-compartir-txt]');
      if (navigator.share && !conRaton.matches) { navigator.share({ title: comp.dataset.titulo, url: url }).catch(function () {}); return; }
      var listo = function () { txt.textContent = 'Enlace copiado'; comp.classList.add('es-copiado'); setTimeout(function () { txt.textContent = 'Compartir'; comp.classList.remove('es-copiado'); }, 2000); };
      if (navigator.clipboard) navigator.clipboard.writeText(url).then(listo).catch(function () {}); else listo();
    });

    // ================= VISTOS RECIENTEMENTE (los usa sections/mt-vistos.liquid) =================
    try {
      var h = D.handle, l = JSON.parse(localStorage.getItem('mt-vistos') || '[]').filter(function (x) { return x !== h; });
      l.unshift(h);
      localStorage.setItem('mt-vistos', JSON.stringify(l.slice(0, 10)));
    } catch (e) {}
  }

  function todo() { document.querySelectorAll('[data-mt-ficha]').forEach(iniciar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todo); else todo();
  document.addEventListener('shopify:section:load', todo);
})();
